import { Alert } from '@papercutsoftware/pcds-react'
import { ErrorMessage } from '@/utils/errorCodes'

export const renderError = (error: ErrorMessage) => {
  return <Alert severity={'error'} title={error.title} content={error.content} />
}
